import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

type SetValue = (
  name: 'image' | 'previewImage',
  value: File | string | null,
  config?: { shouldValidate?: boolean }
) => void;

type UseStreamImageUploadArgs = {
  setValue: SetValue;
};

export const useStreamImageUpload = ({
  setValue,
}: UseStreamImageUploadArgs) => {
  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      setValue('image', acceptedFiles[0], { shouldValidate: true });
    },
    [setValue]
  );

  const handleApplyImage = useCallback(
    (image: File) => {
      setValue('previewImage', URL.createObjectURL(image), {
        shouldValidate: true,
      });
      setValue('image', image, { shouldValidate: true });
    },
    [setValue]
  );

  const handlePreviewImageRemove = useCallback(() => {
    setValue('previewImage', '', { shouldValidate: true });
    setValue('image', null, { shouldValidate: true });
  }, [setValue]);

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop,
    maxFiles: 1,
    accept: 'image/jpg, image/jpeg, image/png',
    noClick: true,
  });

  return {
    getRootProps,
    getInputProps,
    open,
    handleApplyImage,
    handlePreviewImageRemove,
  };
};
